
	import Component from 'vue-class-component'
	import StylePopup from './components/stylePopup/stylePopup';
	import moduleStore from './store/videoEditor';
	import Vue from 'vue';
	import PageState from './store/state';
	import player from './components/player/player';
	import TabBar from './components/tabBar/tabBar';
	import SpeakerPopup from './components/speakerPopup/speakerPopup';
	import PronunciationPopup from './components/pronunciationPopup/pronunciationPopup';
  import ChooseBgm from '../chooseBgm/chooseBgm';
	import SearchSpeaker from '../searchSpeaker/searchSpeaker';
	import BgVolume from './components/bgVolume/bgVolume.vue'
	import { TabTypeMap } from './utils/constant';
  import { judgeDeviceType } from '@/utils/device'
	import { Provide } from 'vue-property-decorator';
	import * as Diff from 'diff';
import { handleDiffList, debouncedSaveArticle } from './utils/utils';

	interface ImgItem {
		imgUrl: string
		startTime: number
		endTime: number
		animateType?: string
	  }
	/**components**/
	@Component({
		components: {
			player,
			StylePopup,
			TabBar,
      ChooseBgm,
			SpeakerPopup,
			SearchSpeaker,
			BgVolume,
			PronunciationPopup
		}
	})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class videoEditorPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		visible = false; // 字体、样式弹窗是否显示
		speakerVisible = false; // 发音人弹窗是否显示
    bgVisible = false;// 背景音 是否显示
    bgmVisible = false;// 背景音乐选择 是否显示 
		canvaDom:any=null
		imgList: ImgItem[] = [];
		isShowBottom = true;
		animationType=  ["PullInUp", "PullInDown", "PullInLeft", "PullInRight", "ZoomIn", "ZommInX", "ZoomInY", "SlideInUp", "SlideInDown", "SlideInLeft", "SlideInRight", "PressInUp", "PressInDown", "PressInLeft", "PressInRight", "PressInX", "PressInY", "UncoverFromTop", "UncoverFromBottom", "ShutterX", "ShutterY", "ZoomFullScreen", "Wheel", "Tooth", "FadeIn", "FadeOut", "StackInTop", "StackInBottom", "StackInLeft", "StackInRight", "TopLaser", "BottomLaser", "RightLaser", "LeftLaser"]
		playerRef: any = null       
		bgmRef: any = null
		stylePopupRef: any = null
		speakerPopupRef: any = null
		speakerInfo: any = {}
    isApp =judgeDeviceType.isAPP;
		scaleRatio = ''
		isShowVolume = false;
		// 要改变的多音字列表
		changeWordList = [];
		// 要改变的数字读音列表
		changeNumberList = [];
		multitoneWordList = []
		// 当前最新字幕
		currentSubtitlesText = ''
		oldSubtitlesText = ''
		orginialNumberTextList = []
		// 字幕变化
		diffList = []
		isChangeText = false
    	// bgMusicRef : any = null 
		// service?: service;
		// controller?: controller;
		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
			// 获取文字模板列表
			this.getTextTemplateList()
		}
		mounted(moduleData:IinjectDatas){
			/*this.$http("getDataList",{}).then((response:any)=>{
				console.log(response)
			}).catch((ex:any)=>{
				console.log(ex)
			})*/
      (window as any).hideBgmPop = this.hideBgmPop;
			this.state.title="这是更改后的title"
			this.state.self = this;
			this.$nextTick(() => {
				this.playerRef = this.$refs.playerRef
				this.stylePopupRef = this.$refs.stylePopupRef
				this.speakerPopupRef = this.$refs.speakerPopupRef
        this.bgmRef = this.$refs.bgmRef
			})
			this.$bus.$on(this.$EventBusKey.CANVASPLAY, this.canvasPlay)
			this.$bus.$on(this.$EventBusKey.REQUEST_SAVE_ARTICLE, this.requestSaveArticle)
			this.$bus.$on(this.$EventBusKey.SAVE_DATA, this.saveData)
			this.$bus.$on(this.$EventBusKey.CHANGE_POLYPHONE, this.changePolyphone)
			this.$bus.$on(this.$EventBusKey.CHANGE_NUMBER, this.changeNumber)

			this.$bus.$on(this.$EventBusKey.EDIT_TEXT_TEMPLATE, this.handleEditTextTemplate)
		}
	
		beforeDestroy() {
		  this.playerRef.reCreateAudio('save-article')
			this.playerRef.saveVideoPromot()
			this.removeBus()
		}
		removeBus() {
			this.$bus.$off(this.$EventBusKey.CANVASPLAY, this.canvasPlay)
			this.$bus.$off(this.$EventBusKey.REQUEST_SAVE_ARTICLE, this.requestSaveArticle)
			this.$bus.$off(this.$EventBusKey.SAVE_DATA, this.saveData)
			this.$bus.$off(this.$EventBusKey.CHANGE_POLYPHONE, this.changePolyphone)
			this.$bus.$off(this.$EventBusKey.CHANGE_NUMBER, this.changeNumber)
		}
		
		@Provide('triggerEditorSubtitle')
		addListenEditorSubtitle(val, type) {
			this.visible = true;
			this.stylePopupRef.setParams(type || TabTypeMap.EDITFONT, {
				...val,
				source: 'cover'
			})
			// console.log('addListenEditorSubtitle', val)
		}
		// 保存数据
		saveData() {
			this.playerRef.saveProject()
		}
		/**
		 * 多音字读法改变
		 */
		changePolyphone(polyList) {
			console.log('changePolyphone', polyList)
			this.multitoneWordList = polyList
			this.changeWordList = polyList.filter(item => item.curpinyin && item.curpinyin)
		}
		/**
		 * 数字读法改变
		 */
		changeNumber(info) {
			this.changeNumberList = info.filterList
			this.orginialNumberTextList = info.orginialTextList

		}
		// 视频播放
		canvasPlay() {
			this.visible = false
			this.speakerVisible = false
			this.bgVisible = false
		}
		/**
		 * 请求保存文章
		 */
		requestSaveArticle() {
			this.playerRef.saveVideoPromot()
		}
		
		/**
		 * 点击字幕
		 * @param params
		 */
		editorSubtitleClick(params) {
			this.visible = true;
			this.stylePopupRef.setParams(TabTypeMap.EDITFONT, params)
		}
		setScaleRatio(ratio) {
			this.scaleRatio = ratio
		}
		/**
		 * 编辑字幕
		 */
		editorSubtitle(text) {
			this.currentSubtitlesText = text
			this.playerRef.updateSubtitles(text)
		}
		changeBottomStatus(status) {
			this.isShowBottom = status
		}
		/**
		 * 切换tab数据
		 * @param type
		 * @param params 
		 */
		changeTabList(params) {
			if (params.type === TabTypeMap.SPEAKER) {
				this.speakerInfo = params.param
			
			}
			(this.$refs.tabBarRef as any).changeTabList(params);
		}
		getPlayerSpeaker(info){
			this.speakerInfo=info
		}
		changeTab(tabType, params) {
			console.log('changeTab--tabType', tabType)
			console.log('changeTab--params', params)
			switch(tabType) {
				// 编辑封面
				case TabTypeMap.COVER:
					this.playerRef.showCoverPopup()
					break;
				// 编辑文字
				case TabTypeMap.EDITFONT:
				case TabTypeMap.FONT:
				case TabTypeMap.WORDPRON:
				case TabTypeMap.NUMPRON:
					this.visible = true
					this.stylePopupRef.setParams(tabType, params)
					break;
				// 编辑图片
				case TabTypeMap.EDITIMG:
					// this.playerRef.playerContainerHeight = 574 / 100
					this.playerRef.showGeneratePickture(params)
					break;
				// 样式
				case TabTypeMap.STYLE:
					this.visible = true
					this.stylePopupRef.setParams(TabTypeMap.STYLE, params)
					break;
				// 字幕
				case TabTypeMap.SUBTITLES:
					if(this.playerRef.isShortPlay) {
						if(!this.playerRef.uuidSelectedText) {
							this.$toast('请选择字幕片段');
						} else {
							this.playerRef.subtitlesEditCallback(this.playerRef.uuidSelectedText);
						}
						return;
					}
					const curSelect = this.playerRef.curSelect
          console.log('curSelect', curSelect)
					if (curSelect && curSelect.type === 'text') {
						this.visible = true
						this.stylePopupRef.setParams(TabTypeMap.EDITFONT, this.playerRef.renderEle)
					} else {
						this.$toast({
							message: '请选择字幕片段'
						})
					}
					break;
				// 发音人
				case TabTypeMap.SPEAKER:
					this.playerRef.trackSpeakerClick()
					break;
				// 配背景音
				case TabTypeMap.MUSIC:
					if(this.isApp){
						let unableBack = (<any>window).unableBack;
						unableBack.postMessage('BGM');
					}
					console.log("music----")
          this.playerRef.onTouchStart()
					this.toChooseBgmList();
					break;
				// 调节声音
				case TabTypeMap.VOLUME:
					this.isShowVolume = true
					break;
				// 编辑配音
				case TabTypeMap.EDITSPEAKER:
					console.log('changeTab', params)
					this.speakerVisible = true
					break;
				// 删除背景音
				case TabTypeMap.DELETEVOLUME:
					this.playerRef.deleteBgm()
					break;
				// 删除当前字幕
				case TabTypeMap.DELFONT:
					break;
				// 删除图片
				case TabTypeMap.DELIMG:
					break;
				// 编辑文字模板
				case TabTypeMap.EDIT_TEXT_TEMPLATE:
					this.visible = true
					this.stylePopupRef.setParams(tabType, params)
					break;
				// 删除文字模板
				case TabTypeMap.DELETE_TEXT_TEMPLATE:
					this.state.savedTextTemplate = {
						// 模板 id
						id: null,
						// 文字模板的文本
						text: '',
						// 缩放比例
						scale: 1,
						// 素材宽度
						width: 0,
						// 素材高度
						height: 0,
						// x 轴距离 %
						x: 0,
						// Y 轴距离 %
						y: 0
					}
					this.state.operatingTextTemplate = {
						// 模板 id
						id: null,
						// 文字模板的文本
						text: '',
						// 缩放比例
						scale: 1,
						// 素材宽度
						width: 0,
						// 素材高度
						height: 0,
						// x 轴距离 %
						x: 0,
						// Y 轴距离 %
						y: 0
					}
					// 移除编辑状态
					this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, false)
					break;
			}
			
		}
		/**
		 * 关闭弹窗
		 */
		closeStylePopup() {
			this.visible = false
			this.playerRef.hideEdit()
			this.diffList = []
			this.isChangeText = false
			this.changeWordList = []
			this.multitoneWordList = []
			this.changeNumberList = []
			this.orginialNumberTextList = []
			this.oldSubtitlesText = ''
			this.stylePopupRef.oldSubtitlesText = ''
			this.currentSubtitlesText = ''
		}
		/**
		 * 弹窗确认
		 */
		confirmStylePopup(source) {
			if (source === 'cover') {
				this.closeStylePopup()
				return
			} else if (source === 'text_template') {
				// 设置文字模板
				if (this.state.operatingTextTemplate.id === this.state.savedTextTemplate.id && this.state.operatingTextTemplate.text === this.state.savedTextTemplate.text) {
					// 取消编辑状态
					this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, false)
					// 关闭弹窗
					this.closeStylePopup()
					return
				}
				// 取消编辑状态
				this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, false)
				// 关闭弹窗
				this.closeStylePopup()
				// 保存参数
				this.state.savedTextTemplate = {
					...this.state.operatingTextTemplate
				}
				// 保存文章
				debouncedSaveArticle(this)
				return
			}
			const oldSubtitlesText = this.stylePopupRef.oldSubtitlesText
			this.oldSubtitlesText = oldSubtitlesText
			console.log('oldSubtitlesText', oldSubtitlesText)
			if (!this.currentSubtitlesText) {
				this.currentSubtitlesText = this.stylePopupRef.subtitlesText
			}
			const diffList = Diff.diffChars(oldSubtitlesText, this.currentSubtitlesText)
			this.diffList = handleDiffList(diffList, this.currentSubtitlesText)
			console.log('diffList', this.diffList)
			const filterList = this.diffList.filter(item => item.added === true || item.removed === true || item.replaced === true)
			this.isChangeText = filterList.length > 0;
			
			if (this.isChangeText) {
				(this.$refs.pronunciationPopupRef as any).show = true
			} else if (this.changeWordList.length || this.changeNumberList.length) {
				this.playerRef.getCurTTsWordVOList({
					diffList: this.diffList,
					pinyinWordList: this.multitoneWordList,
					numberWordList: this.changeNumberList,
					orginialNumberTextList: this.orginialNumberTextList,
					checkedInfo: {
						isEditChecked: false,
      			isWordChecked: true,
      			isNumChecked: true
					},
					currentText: this.currentSubtitlesText
				})
				this.closeStylePopup()
			} else {
				this.closeStylePopup()
			}
		}
		/**
		 * 确认修改
		 */
		confirmEdit(info) {
			this.playerRef.getCurTTsWordVOList({
				diffList: this.diffList,
				pinyinWordList: this.multitoneWordList,
				numberWordList: this.changeNumberList,
				orginialNumberTextList: this.orginialNumberTextList,
				checkedInfo: info,
				currentText: this.currentSubtitlesText
			})
			this.closeStylePopup()
		}
		cancelEdit() {
			const curText = this.stylePopupRef.subtitlesText
			const oldText = this.stylePopupRef.oldSubtitlesText
			if (curText !== oldText) {
				this.editorSubtitle(oldText)
				this.requestSaveArticle()
			}
			
			this.closeStylePopup()
		}
		changeSpeaker(speakerInfo) {
			this.speakerInfo = speakerInfo;
			this.playerRef.updateSpeakerAudio(speakerInfo)
		}
    changeBgm(bgmInfo){
      console.log('---app确认了背景音',bgmInfo)
      this.playerRef.updateBackAudio(bgmInfo)
    }
		syncSpeaker(speakerInfo){
			this.speakerInfo = speakerInfo
		}
		updateBgVolume(value) {
			(this.$refs.bgVolumeRef as any).volume = Math.floor(value * 100)
		}
		/**
		 * 改变声音
		 * @param value
		 */
		onChangeVolume(value) {
			this.playerRef.changeBgVolume(value)
		}
		onConfirmVolume() {
			this.isShowVolume = false
		}
    toChooseBgmList(){
			console.log("music----toChooseBgmList", this.isApp)
      if(this.isApp){
        this.bgmVisible = true;
      }else{//小程序
        const ww_token = localStorage.getItem('ww_token')
        this.$navigateTo({
          url: "/baohuo-package/pages/choose-bgm/choose-bgm?ww_token="+ww_token,
        })
      }
    }
    hideBgmPop(){
      this.bgmVisible = false;
    }
		doClickVideoEditor() {
			this.$bus.$emit('doClickVideoEditor');
		}
		
		/****************************** 文字模板 ******************************/

		handleEditTextTemplate() {
			this.visible = true
			this.stylePopupRef.setParams(TabTypeMap.EDIT_TEXT_TEMPLATE, {
				...this.state.operatingTextTemplate,
				source: 'text_template'
			})
		}

		/** 获取提供的文字模板列表 */
		getTextTemplateList() {
			this.$http('getTextTemplateListApi')
				.then(res => {
					const { code, data } = res
					if (code === 200) {
						this.state.defaultTextTemplateList = data
					}
				})
		}

	}